<template>
  <b-modal
    id="modal-list-security-answers"
    hide-footer
    centered
    size="lg"
    :noCloseOnBackdrop="true"
    :noCloseOnEsc="true"
    :hideHeaderClose="true"
  >
    <div
      class="col-12 d-flex flex-column align-items-center p-0"
      style="position: relative; z-index: 1"
    >
      <img
        class="centerImg1"
        src="@/assets/images/icons/alert-line.svg"
        width="20%"
      />
      <h3 class="pt-3 font-weight-bold mb-4">Preguntas de seguridad</h3>
      <b-alert show variant="warning" class="alert-warning-message">
        <div class="d-flex">
          <div class="mr-3">
            <img
              src="@/assets/images/icons/alert-line.svg"
              alt=""
              width="28px"
              height="28px"
            />
          </div>
          <p style="font-size: 14px; color: #263238; margin-bottom: 0">
            Para continuar responde las siguientes preguntas de seguridad
          </p>
        </div>
      </b-alert>

      <div class="w-100">
        <b-overlay :show="loading" rounded="sm">
          <template #overlay>
            <OverlayButton clase="overlay-md"> </OverlayButton>
          </template>
          <div class="row w-100 mt-5">
            <b-col
              cols="12"
              class="mb-5"
              v-for="(quest, index) in questions"
              :key="index"
            >
              <Input
                :label="quest?.name"
                :name="`question-${index}`"
                :value="quest.answer"
                :required="true"
                @input="(event) => (quest.answer = event.target.value)"
              />
            </b-col>
          </div>
        </b-overlay>
      </div>
      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
        v-if="!loading"
      >
        <button
          class="button_primary"
          @click.prevent="saveQuestion()"
          :disabled="isBusy || validateAnswer"
        >
          <span class="cta">Guardar Respuestas</span>
          <b-spinner v-if="isBusy" />
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import securitySevices from "@/services/legal/security/service.js";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

import useInputs from "@/components/general/Inputs";

const { Input } = useInputs();
export default {
  props: {
    isFirstTime: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Input,
    OverlayButton,
  },
  data() {
    return {
      isBusy: false,
      loading: true,
      questions: [],
    };
  },
  watch: {
    isFirstTime() {
      const me = this;
      if (me.isFirstTime) me.loadListSecurityAnswers();
    },
  },
  computed: {
    validateAnswer() {
      const me = this;
      let result = false;
      me.questions.forEach((x) => {
        if (x.answer == "") {
          result = true;
        }
      });
      return result;
    },
  },
  methods: {
    async loadListSecurityAnswers() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await securitySevices.getRandomQuestion();
        data?.forEach((item) => {
          me.questions.push({
            id: item.id,
            name: item.question,
            answer: "",
          });
        });
        console.log(me.questions);
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    async saveQuestion() {
      const me = this;
      me.isBusy = true;
      let formData = {
        answers: [],
      };
      me.questions.forEach((x) => {
        formData.answers.push({
          security_question_id: x.id,
          answer: x.answer,
        });
      });
      try {
        await securitySevices.saveQuestion(formData);
        me.$emit("onSuccess", "Se han guardado las preguntas de seguridad");
      } catch (error) {
        console.log(error);
        me.$emit("onError", "Error al guardar las preguntas de seguridad");
      } finally {
        me.isBusy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
